module.exports = __webpack_public_path__ + "img/dragoonsoft_slot.aa28555b.png";